module.exports = __webpack_public_path__ + "static/img/21.89518500.png";